module.exports = __webpack_public_path__ + "static/media/lifestyle-intro-animation.fcdd2e96.svg";